import { render, staticRenderFns } from "./ConfettiRain.vue?vue&type=template&id=66c91afa&scoped=true"
import script from "./ConfettiRain.vue?vue&type=script&lang=js"
export * from "./ConfettiRain.vue?vue&type=script&lang=js"
import style0 from "./ConfettiRain.vue?vue&type=style&index=0&id=66c91afa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c91afa",
  null
  
)

export default component.exports